let sideBarOpenButton = document.querySelector('[size-chart-popup]');
let sideBarCloseButton = document.querySelector('[sizechart-popup-close]');
// let outsidedCloseButton = document.getElementById('popup-content');
sideBarOpenButton.addEventListener('click', function (e) {
    e.preventDefault();
    document.body.classList.add('show_sizechart_popup');
});
sideBarCloseButton.addEventListener('click', function (e) {
    e.preventDefault();
    document.body.classList.remove('show_sizechart_popup');
});
// outsidedCloseButton.addEventListener('click', function (e) {
//     e.preventDefault();
//     document.body.classList.remove('show_sizechart_popup');
// });
window.addEventListener('DOMContentLoaded', function () {
    let popupContent = document.getElementById('popup-content');
    document.body.appendChild(popupContent);

});